import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';
import { displayOrDash } from '#/modules/crmMgmt/customerOrder/helper/mapCustomerOrderMeta';

const CrmCustomerSnapshotMeta = ({ snapshot }) => (
  <div
    className={cn(
      'grid grid-cols-1 gap-x-4 gap-y-3',
      'md:grid-cols-2',
    )}
  >
    <div>
      <p className="text-xs text-gray-500">客戶代號</p>
      <p className="mt-0.5 text-sm font-medium wrap-anywhere text-gray-900">
        {displayOrDash(snapshot?.customerCode)}
      </p>
    </div>
    <div>
      <p className="text-xs text-gray-500">客戶名稱</p>
      <p className="mt-0.5 text-sm font-medium wrap-anywhere text-gray-900">
        {displayOrDash(snapshot?.customerName)}
      </p>
    </div>
    <div>
      <p className="text-xs text-gray-500">發票抬頭</p>
      <p className="mt-0.5 text-sm font-medium wrap-anywhere text-gray-900">
        {displayOrDash(snapshot?.invoiceTitle)}
      </p>
    </div>
    <div>
      <p className="text-xs text-gray-500">統編</p>
      <p className="mt-0.5 text-sm font-medium wrap-anywhere text-gray-900">
        {displayOrDash(snapshot?.taxIdNumber)}
      </p>
    </div>
    <div>
      <p className="text-xs text-gray-500">稅籍國別</p>
      <p className="mt-0.5 text-sm font-medium wrap-anywhere text-gray-900">
        {displayOrDash(snapshot?.taxCountryCode)}
      </p>
    </div>
  </div>
);

CrmCustomerSnapshotMeta.propTypes = {
  snapshot: PropTypes.object,
};

export default CrmCustomerSnapshotMeta;
